export default {
    apiUrl: process.env.NODE_ENV === "development" ? "http://localhost:4000" : "https://superelfapi.azurewebsites.net",
    recaptchaSite: "6LcSHbYgAAAAAGxfaoNFDaAUJBVjJ-cbh_Mayi__",
    appInsite: "InstrumentationKey=25261265-9c72-42be-aae9-19c7b3515846;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/"
}